import { render, staticRenderFns } from "./employee-request-unread-counter.vue?vue&type=template&id=ce3aab9a"
import script from "./employee-request-unread-counter.vue?vue&type=script&lang=js"
export * from "./employee-request-unread-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports